/* Model */
class EquipmentModel extends App.Models.BaseModel {
    modelUrl = 'Equipment';
}

App.Models.Equipment = EquipmentModel;

/* Collection */
class EquipmentCollection extends App.Collections.BaseCollection {
    url = 'Equipment';
    model = App.Models.Equipment;
}

App.Collections.Equipments = EquipmentCollection;

/* Router */
class EquipmentRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'Equipment';
        const model = App.Models.Equipment;
        const collectionClass = App.Collections.Equipments;

        super(entityName, model, collectionClass);
    }
}

App.Routers.Equipment = EquipmentRouter;
